import React, { useEffect } from 'react';
import { Tabs, Tab, Paper, Typography, Box, makeStyles } from '@material-ui/core';
import ManageRelations from '../ManageRelations';
import ErrorDiagnosis from '../ErrorDiagnosis/index';
import TransformationSpecGrid from '../TransformationSpec';
import NotificationGrid from '../Notification/index';
import ServiceCertification from '../Certifications/ServiceCertification';
import CertificationTestScenario from '../Certifications/CertificationTestScenario';
import { useHistory, useParams } from 'react-router-dom';
import ErrorDiagnosiss from '../ED';

const useStyles = makeStyles(theme => ({
  tab: {
    borderBottomStyle: 'none !important' as 'none'
  }
}));

interface TabPanelProps {
  children: React.ReactNode;
  value: string;
  index: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <Typography component="div" role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`}>
      {value === index && <Box>{children}</Box>}
    </Typography>
  );
}

interface ProviderTabsProps {
  participant: participant;
  workflowCode: string;
}

type participant = {
  [key: string]: any;
};

const ProviderServiceTabs = (props: ProviderTabsProps) => {
  const classes = useStyles();
  let { serviceTab } = useParams();
  const [value, setValue] = React.useState(serviceTab || 'errorDiagnosis');
  const history = useHistory();

  useEffect(() => {
    setValue('errorDiagnosis');
  }, [props.workflowCode]);

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
    window.history.pushState(
      '',
      '',
      `/participant/${window.location.pathname.split('/')[2]}/service/${window.location.pathname.split('/')[4]}` +
        '/' +
        newValue
    );
    setValue(newValue);
  };

  // const [value, setValue] = React.useState(tab);
  // const handleChange = (_event: React.ChangeEvent<{}>, newValue: string) => {
  //   window.history.pushState('', '', '/participant/' + props.participantCode + '/' + newValue);
  //   props.enableDetail(false);
  //   setValue(newValue);
  // };

  return (
    <Paper variant="outlined">
      <Tabs data-id="tabs" value={value} onChange={handleChange}>
        <Tab
          label={
            props.participant.participantType === 'CUSTOMER' || props.participant.participantType === 'AGGREGATOR'
              ? 'Providers'
              : 'Customers'
          }
          className={classes.tab}
          value="manageRelation"
        />
        <Tab label="Error Diagnosis" className={classes.tab} value="errorDiagnosis" />
        {props.workflowCode !== 'freightTracking' && (
          <Tab label="Notifications" className={classes.tab} value="notification" />
        )}
        {props.participant.participantType !== 'AGGREGATOR' && props.workflowCode !== 'freightTracking' && (
          <Tab label="Transformation" className={classes.tab} value="transformation" />
        )}
        <Tab label="Simulation" className={classes.tab} value="simulation" />
        {(props.participant.participantType === 'CUSTOMER' || props.participant.participantType === 'PROVIDER') && (
          <Tab label="Certification" className={classes.tab} value="certification" />
        )}
        {/* <Tab label="ED" className={classes.tab} value="errorDiagnosiss" /> */}
      </Tabs>
      <TabPanel value={value} index="manageRelation">
        <ManageRelations {...props} />
      </TabPanel>
      {/* {sessionStorage.getItem('enableED') === 'true' && (
        <TabPanel value={value} index="errorDiagnosis">
          <ErrorDiagnosis id="ErrorDiagnosis" {...props} history={history} search={history?.location?.search} />
        </TabPanel>
      )} */}
      {/* {sessionStorage.getItem('enableED') === 'false' && ( */}
      <TabPanel value={value} index="errorDiagnosis">
        <ErrorDiagnosiss
          id="ErrorDiagnosis"
          {...props}
          history={history}
          search={history?.location?.search}
          isServiceLevel
        />
      </TabPanel>
      {/* )} */}
      <TabPanel value={value} index="notification">
        <NotificationGrid workflowCode={props.workflowCode} />
      </TabPanel>
      <TabPanel value={value} index="transformation">
        <TransformationSpecGrid {...props} />
      </TabPanel>
      <TabPanel value={value} index="simulation">
        <ServiceCertification {...props} />
      </TabPanel>
      <TabPanel value={value} index="certification">
        <CertificationTestScenario {...props} />
      </TabPanel>
    </Paper>
  );
};

export default ProviderServiceTabs;
